import './App.css';
import About from './components/About';
import Experience from './components/Experience';
import Footer from './components/Footer';
import Header from './components/Header';
import Project from './components/Project';
import Skill from './components/Skill';

function App() {
  return (
    <>
      <Header />
      <About />
      <Project />
      <Skill />
      <Experience />
      <Footer />
    </>
  );
}

export default App;
